import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Capacitor } from "@capacitor/core";
import {
  ActionPerformed,
  PushNotifications,
  PushNotificationSchema,
  Token,
} from "@capacitor/push-notifications";
import { BehaviorSubject } from "rxjs";
import { domain } from "../variables/domain";
import { Device } from "@capacitor/device";
import { map } from "rxjs/operators";
import { EncryptionService } from "./encryption.service";
import { SharedServices } from "./shared.service";
// import { StorageService } from '../storage/storage.service';
export const FCM_TOKEN = "push_notification_token";
@Injectable({
  providedIn: "root",
})
export class NotificationsService {
  private _redirect = new BehaviorSubject<any>(null);
  get redirect() {
    return this._redirect.asObservable();
  }
  constructor(
    private http: HttpClient,
    private encryptionService: EncryptionService ,//     private storage: StorageService,
    private sharedServices: SharedServices
  ) {}
  initPush() {
    if (Capacitor.getPlatform() !== "web") {
      this.registerPush(); // this.getDeliveredNotifications();
    }
  }
  private async registerPush() {
    try {
      await this.addListeners();
      let permStatus = await PushNotifications.checkPermissions();
      // [Log] permStatu===> – {receive: "prompt"} (main.js, line 1555)
      if (permStatus.receive === "prompt") {
        permStatus = await PushNotifications.requestPermissions();
      }
      if (permStatus.receive !== "granted") {
        throw new Error("User denied permissions!");
      }
      await PushNotifications.register();
    } catch (e) {
    }
  }
  async getDeliveredNotifications() {
    const notificationList =
      await PushNotifications.getDeliveredNotifications();
  }
  addListeners() {
    PushNotifications.addListener("registration", (token: Token) => {
      // const fcm_token = token?.value;
      // let go = 1;
      // if (token) {
      // setTimeout(()=> {
      let deviceid: any;
      let DeviceType: any;
      Device.getInfo().then((res) => {
        DeviceType = res.operatingSystem;
      });
      Device.getId().then((res) => {
        deviceid = res.identifier;
      });
      let userId: any=null;
      if (this.sharedServices.getAgentId()) {
        userId = this.sharedServices.getAgentId();
      } else {
        userId = null;
      }
      setTimeout(() => {
        const object: any = {
          MobileDeviceId: deviceid,
          DeviceType: DeviceType,
          DeviceToken: token.value,
          UserId: userId,
        };

        this.SaveDeviceDetails(object).subscribe((res) => {
          // 
        });
      }, 1000);
      
    });
    PushNotifications.addListener("registrationError", (error: any) => {
    });
    PushNotifications.addListener(
      "pushNotificationReceived",
      async (notification: PushNotificationSchema) => {
        const data = notification?.data;
        if (data?.redirect) this._redirect.next(data?.redirect);
      }
    );
    PushNotifications.addListener(
      "pushNotificationActionPerformed",
      async (notification: ActionPerformed) => {
        const data = notification.notification.data;
        //   "Action performed: " + JSON.stringify(notification.notification)
        // );
        if (data?.redirect) this._redirect.next(data?.redirect);
      }
    );
  }
  async removeFcmToken() {
    //   try {
    //     const saved_token = JSON.parse(
    //       (await this.storage.getStorage(FCM_TOKEN)).value
    //     );
    //     this.storage.removeStorage(saved_token);
    //   } catch (e) {
    //     throw e;
    //   }
  }

  SaveDeviceDetails(object) {
    return this.http
      .post(domain.Notification + "SaveDevice", object)
      .pipe(map((res:any) => res));
  }

  getNotificationsList(skip, take) {

    const userId=this.encryptionService.decryptUsingAES256( JSON.parse(localStorage.getItem('a_n_d')));
    return this.http
      .get(
        domain.Notification +
          "GetNotificationList?skip=" +
          skip +
          "&Take=" +
          take+"&UserId="+userId
      )
      .pipe(map((res:any) => res));
  }
}
